const ORDER_ANALYTICS = {
  action: 'order_action'
} as const

type PosthogCapture = {
  capture: (event: string, properties?: Record<string, unknown>) => void
}

export type OrderAction =
  | 'close'
  | 'edit'
  | 'history'
  | 'documents'
  | 'report'
  | 'status_change'
  | 'matching_filter'
  | 'matching_sort'
  | 'matching_toggle'
  | 'view_kanban'

export const captureOrderAction = (
  posthog: PosthogCapture,
  action: OrderAction,
  properties: Record<string, unknown> = {}
) => {
  posthog.capture(ORDER_ANALYTICS.action, {
    source: 'react',
    action,
    ...properties
  })
}
